import { SingleItem } from "./SingleItem";

export default SingleItem;
